// T034 — Client-side Statsig provider using @statsig/react-bindings.
// Receives pre-evaluated values from server; provides client-side gate checks
// and event logging.

import { StatsigClient } from '@statsig/js-client';

let clientInstance: StatsigClient | null = null;

export function initializeStatsigClient(clientKey: string, userId?: string): StatsigClient {
  if (clientInstance) {
    return clientInstance;
  }

  clientInstance = new StatsigClient(clientKey, { userID: userId ?? '' });
  return clientInstance;
}

export function getStatsigClient(): StatsigClient | null {
  return clientInstance;
}

/**
 * The per-browser Statsig stable ID (cookie + localStorage persisted), or null
 * when the client isn't initialised yet / stableID generation is disabled.
 * Used as a coarse device signal for the referral device-collusion gate — a
 * best-effort signal, so any read failure resolves to null (never throws into the
 * request path that consumes it).
 */
export function getStatsigStableId(): string | null {
  try {
    return clientInstance?.getContext().stableID ?? null;
  } catch {
    // SILENT-CATCH: best-effort device signal — any read failure resolves to null so
    // it never throws into the request path that consumes it (see JSDoc above).
    return null;
  }
}

export function shutdownStatsigClient(): void {
  if (clientInstance) {
    clientInstance.shutdown();
    clientInstance = null;
  }
}
